if (!customElements.get('ambassador-circles')) {
  customElements.define(
    'ambassador-circles',
    class AmbassadorCircles extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-circles-track]');
        this.dotsWrap = this.querySelector('[data-circles-dots]');
        this.circles = [...this.querySelectorAll('[data-circle]')];
        if (!this.track || !this.circles.length) return;

        this.count = this.circles.length;
        this.createClones();

        this.onScroll = this.onScroll.bind(this);
        this.onScrollEnd = this.onScrollEnd.bind(this);
        this.onResize = this.onResize.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.renderDots();
        if (this.isScrollable()) this.scrollToIndex(this.count > 2 ? 1 : 0, 'instant');
        this.updateDots();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        clearTimeout(this.scrollTimer);
      }

      createClones() {
        const makeClone = (circle) => {
          const clone = circle.cloneNode(true);
          clone.removeAttribute('data-circle');
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('data-circle-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          return clone;
        };

        const before = this.circles.map(makeClone);
        const after = this.circles.map(makeClone);
        this.track.prepend(...before);
        this.track.append(...after);
        this.items = [...this.track.children];
      }

      isScrollable() {
        return this.track.scrollWidth - this.track.clientWidth > 1;
      }

      setWidth() {
        return this.items[this.count * 2].offsetLeft - this.items[this.count].offsetLeft;
      }

      onResize() {
        this.renderDots();
        if (this.isScrollable()) this.scrollToIndex(this.activeIndex ?? 0, 'instant');
        this.updateDots();
      }

      renderDots() {
        this.dotsWrap.innerHTML = '';
        this.dots = [];
        if (!this.isScrollable()) return;

        this.dots = this.circles.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `${index + 1} / ${this.count}`);
          dot.addEventListener('click', () => this.scrollToIndex(index, 'smooth'));
          this.dotsWrap.appendChild(dot);
          return dot;
        });
      }

      scrollToItem(item, behavior) {
        const left = item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior });
      }

      scrollToIndex(index, behavior) {
        this.scrollToItem(this.items[this.count + index], behavior);
      }

      centeredItemIndex() {
        const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        let closest = 0;
        let minDistance = Infinity;

        this.items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < minDistance) {
            minDistance = distance;
            closest = index;
          }
        });

        return closest;
      }

      onScroll() {
        this.updateDots();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(this.onScrollEnd, 120);
      }

      onScrollEnd() {
        if (!this.isScrollable()) return;

        const index = this.centeredItemIndex();
        if (index >= this.count && index < this.count * 2) return;

        const shift = index < this.count ? this.setWidth() : -this.setWidth();
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft += shift;
        requestAnimationFrame(() => {
          this.track.style.scrollSnapType = '';
        });
      }

      updateDots() {
        this.activeIndex = this.centeredItemIndex() % this.count;
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.activeIndex));
      }
    }
  );
}
